import VideoControlStyle from "./video-control.module.scss";
import  * as React from "react";
import { observer } from "mobx-react";
import {IVideoControlProps} from "./IVideoControlProps";
import { SingleVideo } from "../SingleVideo/SingleVideo";
import { IReportVideo, ReportKind} from "Data";


@observer
export class VideoControl extends React.Component<IVideoControlProps> {
    private numbersOfVideosToDisplay : number = 2;
    private readonly fixedSelectedVideos: IReportVideo[];

    constructor(props: IVideoControlProps) {
        super(props, undefined);
        
        if (!this.props.selectedVideos || this.props.selectedVideos.length !== this.numbersOfVideosToDisplay) {
            const selectedVideos = this.props.selectedVideos || [];
            const selectedVideosLength = (this.props.selectedVideos && this.props.selectedVideos.length) || 0;

            this.fixedSelectedVideos = [
                ...selectedVideos,
                ...(Array<IReportVideo>(this.numbersOfVideosToDisplay - selectedVideosLength) as any).fill(null)
            ];
        } else {
            this.fixedSelectedVideos = this.props.selectedVideos;
        }
    }

    private isGroupReport(): boolean {
        let reportKind = this.props.reportKind;
        return reportKind === ReportKind.multiGroupReport ||
            reportKind === ReportKind.singleGroupReport ||
            reportKind === ReportKind.puttingMultiGroupReport ||
            reportKind === ReportKind.puttingSingleGroupReport;
    }

    private shouldShowAngleButtons() : boolean {
        const videos = this.props.videos && this.props.videos.length;
        return ( videos ?? 0 ) > this.numbersOfVideosToDisplay;
    }

    private onSelectedVideosChanged(video: IReportVideo, index: number) {
        this.fixedSelectedVideos[index] = video;
        this.props.onSelectedVideosChanged(this.fixedSelectedVideos);
    }

    render() {
        let infoBoxContainer = null, rowContainer = null;
        if (this.isGroupReport() && this.props.videos && (this.props.videos.length === 0 || !this.props.selectedStroke)) {
            infoBoxContainer = <div className={VideoControlStyle.infoBoxContainer}>
                <div className={VideoControlStyle.emptyVideoContainer}></div>
                <div className={VideoControlStyle.emptyVideoContainer}></div>
                       {this.props.selectedStrokesGroups && this.props.selectedStrokesGroups.length === 0 &&
                    <div className={VideoControlStyle.infoContainer}>
                           <p>You have no groups selected.</p>
                           <p>Select a group and a shot to activate the optimizer.</p>
                       </div>
                       }
                       {!(this.props.selectedStrokesGroups && this.props.selectedStrokesGroups.length === 0) && !this.props.selectedStroke && !this.props.selectedAverage &&
                    <div className={VideoControlStyle.infoContainer}>
                           <p>You have 0 strokes selected.</p>
                           <p>Select a stroke with the video icon to see the video.</p>
                       </div>
                       }
                       {!(this.props.selectedStrokesGroups && this.props.selectedStrokesGroups.length === 0) && this.props.selectedStroke &&
                    <div className={VideoControlStyle.infoContainer}>
                           <p>The stroke does not include a video.</p>
                           <p>Select a stroke with the video icon to see the video.</p>
                       </div>
                       }
                       {!(this.props.selectedStrokesGroups && this.props.selectedStrokesGroups.length === 0) && this.props.selectedAverage &&
                    <div className={VideoControlStyle.infoContainer}>
                           <p>There is no video for an average.</p>
                           <p>Select 1 stroke below with a video icon to get started.</p>
                       </div>
                      }
                   </div>;
        }
        if (this.props.selectedStroke) {
            let self = this;
            rowContainer = <div className="row">
                    {this.props.videos && this.props.videos.map((video, index) => {
                        if (index < this.numbersOfVideosToDisplay) {
                            return <div key={video.id} className={"single-video" + (self.props.videos && self.props.videos.length === 1 ? " only-one-video" : "")}>
                                        <SingleVideo defaultVideo={video}
                                                selectedVideo={self.fixedSelectedVideos[index]}
                                                videos={self.props.videos!}
                                                showChangeAnglesButton={self.shouldShowAngleButtons()}
                                                alignRight={index % 2 === 1}
                                                isTps={self.props.isTps}
                                                onSelectedVideoChanged={(videoArg: IReportVideo) => this.onSelectedVideosChanged(videoArg,index)}/>
                                    </div>;
                               }
                               return null;
                           })
                       }
                       {this.props.videos && this.props.videos.length === 1 &&
                    <div className={`${VideoControlStyle.infoBoxContainer} ${VideoControlStyle.right}`}>
                    <div className={VideoControlStyle.emptyVideoContainer}></div>
                           </div>
                       }
                   </div>;
        }
        return <div className={VideoControlStyle.videoControl}>
                   {infoBoxContainer}
                   {rowContainer}
               </div>;
    }
}
